const theme = {
  textColor: '#323232',
  primaryColor: '#FF5252',
  maxPageWidth: '1440px',
  paddingPage: '32px',
}

export default theme
